import styled from 'styled-components';

export const ClickerDiv = styled.div`
  _display: flex;
  position: absolute;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100vw;
  background: none;
`;

export default ClickerDiv;
